// Default page size
export const NEWS_ARTICLES_PER_PAGE = 12

// Format a date from the CMS
export const formatNewsDate = (str) =>
  new Intl.DateTimeFormat("en-US", { month: "long", year: "numeric", day: "numeric" }).format(new Date(str))
